import { z } from 'zod';

// ─── Business throw form schema ───────────────────────────────────────────────

export const businessThrowSchema = z.object({
  errorCodeName: z
    .string()
    .min(1, '에러 코드를 선택해 주세요'),
  args: z.string().optional(),
});

export type BusinessThrowFormValues = z.infer<typeof businessThrowSchema>;

// ─── Validation throw form schema ─────────────────────────────────────────────

export const validationThrowSchema = z.object({
  email: z.string().min(1, '이메일을 입력해 주세요'),
  phone: z.string().optional(),
});

export type ValidationThrowFormValues = z.infer<typeof validationThrowSchema>;

// ─── Auth throw form schema ───────────────────────────────────────────────────

export const authThrowSchema = z.object({
  variant: z.enum(['401', '403'], {
    errorMap: () => ({ message: 'variant 는 401 또는 403 이어야 합니다' }),
  }),
});

export type AuthThrowFormValues = z.infer<typeof authThrowSchema>;

// ─── Server throw form schema ─────────────────────────────────────────────────

export const serverThrowSchema = z.object({
  simulate: z.enum(['internal', 'null-pointer', 'illegal-state'], {
    errorMap: () => ({ message: '유효한 시뮬 종류를 선택해 주세요' }),
  }),
});

export type ServerThrowFormValues = z.infer<typeof serverThrowSchema>;

// ─── Response schemas (runtime parse for safety) ─────────────────────────────

export const errorFieldErrorSchema = z.object({
  field: z.string(),
  code: z.string(),
  message: z.string(),
  rejectedValue: z.string().nullable().optional(),
});

export const throwErrorResultSchema = z.object({
  httpStatus: z.number().optional(),
  code: z.string(),
  message: z.string(),
  messageEn: z.string().optional(),
  detail: z.string().nullable().optional(),
  fieldErrors: z.array(errorFieldErrorSchema).nullable().optional(),
  traceId: z.string().optional(),
  timestamp: z.string().optional(),
});

export const errorCodeNodeSchema = z.object({
  code: z.string(),
  httpStatus: z.number(),
  enumName: z.string(),
  messageKey: z.string(),
  messageKo: z.string(),
  messageEn: z.string(),
  throwEndpoint: z.string(),
  exampleArgs: z.array(z.string()),
});

export const errorGroupSchema = z.object({
  prefix: z.string(),
  nodes: z.array(errorCodeNodeSchema),
});

export const errorCatalogResponseSchema = z.object({
  groups: z.array(errorGroupSchema),
  currentTraceId: z.string(),
  currentLocale: z.string(),
});
